const doc = [({"en":({"js":({"user_steps":({"element_types":({"question_file":({"index":({"uploaded_answers":"Uploaded answers"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;